module.exports = __webpack_public_path__ + "static/media/card-image-casaproject-2020.f25079b2.jpg";